import type { Cliente } from '../db/tipos'

// SEM geocodificacao, por decisao da spec: o endereco textual e entregue ao app
// de navegacao, que resolve melhor do que nos resolveriamos aqui -- e sem gastar
// cota de API nem depender de rede para montar o link.
export function enderecoCompleto(cliente: Cliente): string | null {
  const partes = [cliente.endereco, cliente.bairro, cliente.municipio, cliente.uf].filter(
    (parte): parte is string => Boolean(parte && parte.trim()),
  )
  return partes.length > 0 ? partes.join(', ') : null
}

export function urlGoogleMaps(cliente: Cliente): string | null {
  const endereco = enderecoCompleto(cliente)
  if (!endereco) return null
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(endereco)}`
}

export function urlWaze(cliente: Cliente): string | null {
  const endereco = enderecoCompleto(cliente)
  if (!endereco) return null
  return `https://waze.com/ul?q=${encodeURIComponent(endereco)}&navigate=yes`
}
